import React, { useState, useEffect, useRef, useCallback, } from "react";
import "./Russianpokertournment.css";
import "./Leaderboard.css";
import Leaderboard from "../../games/Tournaments/LeaderBoard";
import balla_logo from "../Tournaments/Tournamnetassets/Ballagameslogoicon 1.svg";
import balla_name from "../Tournaments/Tournamnetassets/Group 1.svg";
import russianlogo from "../Tournaments/Tournamnetassets/Ellipse 1.svg";
import tournystutus from "../Tournaments/Tournamnetassets/pajamas_status-health.svg";

import tournycurrency from "../Tournaments/Tournamnetassets/material-symbols-light_money-bag.svg";

import tournydate from "../Tournaments/Tournamnetassets/icon-park_timer (1).svg";

import tournybuyin from "../Tournaments/Tournamnetassets/emojione_money-with-wings.svg";

import tournychips from "../Tournaments/Tournamnetassets/streamline-ultimate_casino-chip-5-bold.svg";

import tournyplayers from "../Tournaments/Tournamnetassets/icon-park-solid_peoples.svg";
import tournyprizepool from "../Tournaments/Tournamnetassets/solar_cup-bold.svg";
import refreshicon from "../Tournaments/Tournamnetassets/fa_refresh (1).svg";
import riverlog from "../Tournaments/Tournamnetassets/riv_logo.svg"


const RussianPokerLobby = ({
    tournaments,
    playertoken,
    gameid,
    siteid,
    gameidrpt,
    onRegisterSuccess,
    Russiantournamnet,
    showGameLaunchPopup


}) => {
    const [loading, setLoading] = useState(false);
    const [loadingpage, setLoadingpage] = useState(false);
    const [successPopup, setSuccessPopup] = useState(false);
    const [errorPopup, seterrorPopup] = useState(false);
    const [errormessage, seterrorMessage] = useState(false);
    const [registeredTournament, setRegisteredTournament] = useState(null);
    const [activeModal, setActiveModal] = useState(null);
    const [modalData, setModalData] = useState([]);
    const [Tournamentboard, setTournmentboard] = useState("");
    const [transactionType, setTransactionType] = useState("");
    const [ActiveModalFinalrank, setActiveModalFinalrank] = useState("");

    const [tournamentList, setTournamentList] = useState([]);
    const [isrigetration, setisrigetration] = useState("");
    const [showTournamentInfo, setShowTournamentInfo] = useState(false);

    const [activeTab, setActiveTab] = useState(null);
    const [isplayerlist, setPlayeslist] = useState(true)
    const [ActiveTournament, setActiveTournament] = useState(null);

    const [players, setPlayers] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const [registeringId, setRegisteringId] = useState(null);

    const [gamelaunchpopup, setGamelaunchpopup] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [launchedTournament, setLaunchedTournament] = useState(null);
    const [isUrl, setUrl] = useState(null);
    const [currentTime, setCurrentTime] = useState(Date.now());
    const statusMap = {
        "CANCELLED_TOURNAMENT_COMPLETED": "CANCELLED",
        "CANCELLED_REFUND_PENDING": "REFUND_PENDING",
        "CANCELLED_REFUND_APPROVED": "REFUND_APPROVED",
        "PENDING_PAYOUT_PROCESS": "PENDING_PAYOUT",
        "PROCESS_PAYOUT": "PROCESS_PAYOUT",
        "PROCESS_PAYOUT_PENDING_APPROVAL": "PAYOUT_APPROVAL",
        "PROCESS_PAYOUT_APPROVED": "PAYOUT_APPROVED",
        "COMPLETED_WITH_NO_PAYOUT": "COMPLETED_NO_PAYOUT"
    };
    const langugaedata = {
        persian: {
            russian_poker: "پوکر روسی",
            status: "وضعیت",
            currency: "ارز",
            startTime: "زمان شروع",
            endTime: "زمان پایان",
            entryFee: "هزینه ورودی",
            chips: "چیپ‌ها",
            prizePool: "مجموع جوایز",
            registeredPlayerList: "بازیکنان ثبت‌نام‌شده",
            register: "ثبت‌نام",
            unregister: "لغو ثبت‌نام",
            play: "بازی",
            playerList: "لیست بازیکنان"
        },
        english: {
            russian_poker: "Russianpoker",
            status: "Status",
            currency: "Currency",
            startTime: "Starts",
            endTime: "Ends",
            entryFee: "BuyIn+Fee",
            chips: "Chips",
            prizePool: "PrizePool",
            registeredPlayerList: "Players",
            register: "Register",
            unregister: "Unregister",
            play: "Play",
            playerList: "Player List"
        }
    };

    const currentLang = "english";
    const tLabel = langugaedata[currentLang];

    let DomainUrl = window.location.hostname
    // console.log("DomainUrl", DomainUrl);
    // let DomainUrl = "bgtms.prep4.live"
    // let DomainUrl = "balladev.undertesting.com"
    // let DomainUrl = "10.10.20.150:9991"

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(Date.now());
        }, 1000);

        return () => clearInterval(interval);
    }, []);


    const handleRegister = async (rptournamentId) => {


        setRegisteringId(rptournamentId);
        const siteface = sessionStorage.getItem("siteId") || null;
        sessionStorage.setItem("TournamentId", rptournamentId);
        setLoading(true);
        try {
            const response = await fetch(`https://${DomainUrl}/ballagames/register`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    playerToken: playertoken,
                    tournamentId: rptournamentId,
                    face: siteface
                }),
            });

            const result = await response.json();

            console.log(result);

            if (result.success) {
                sessionStorage.removeItem("TournamentIdReload");
                getTournamentListEvryfiveseconds();
                Russiantournamnet();

                setRegisteringId(null);
                setRegisteredTournament(rptournamentId);
                setSuccessPopup(true);
                setisrigetration("COMPLETED");
                seterrorPopup(false);
            }
            else {

                seterrorMessage(
                    result.message || "Registration Failed"
                );

                seterrorPopup(true);

                setRegisteringId(null);

                // alert(result.message || "Registration Failed");
            }

        } catch (error) {

            console.error(error);

            seterrorMessage(
                error.message || "Registration Failed"
            );

            seterrorPopup(true);

            // alert(error.message || "Registration Failed");

        } finally {

            setLoading(false);
        }
    };



    const ITEMS_PER_PAGE = 20;


    const fetchPlayers = async (pageNum) => {
        const uid = Date.now() + '-' + Math.random().toString(36).slice(2);
        const tournyid = sessionStorage.getItem("TournamentId");
        const siteface = sessionStorage.getItem("siteId") || null;

        if (loadingpage || !hasMore) return;


        setLoadingpage(true);

        try {
            const response = await fetch(
                `https://${DomainUrl}/ballagames/leaderBoard?tournamentId=${tournyid}&face=${siteface}&page=${pageNum}&size=${ITEMS_PER_PAGE}&uid=${uid}`
            );

            const data = await response.json();

            const newItems = data?.content || [];

            // Save total pages from server (only first time needed)
            setTotalPages(data.totalPages);


            const formattedItems = newItems.map((p) => ({
                id: p.playerId,
                Nickname: p.loginName,
                Rank: p.rank,
                score: p.score,
                Prize: p.prizeAmount,
                chips: p.availableChips
            }));

            setPlayers((prev) => [...prev, ...formattedItems]);

            // 🔥 Stop when last page reached
            if (pageNum + 1 >= data.totalPages) {
                setHasMore(false);
            }

        } catch (error) {
            console.error("Error fetching leaderboard:", error);
        }

        setLoadingpage(false);
    };

    useEffect(() => {
        if (activeModal) {
            fetchPlayers(0);
        }
    }, [activeModal]);



    useEffect(() => {
        if (page > 0) {
            fetchPlayers(page);
        }
    }, [page]);

    useEffect(() => {

        
        if (showGameLaunchPopup) {
            setGamelaunchpopup(true)
        }
    }, [showGameLaunchPopup]);





    useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        let homeURL = params.get("homeUrl") || params.get("homeURL");

        // Step 2: If found in URL → store it
        if (homeURL) {
            sessionStorage.setItem("homeurlredirect", homeURL);
        }


        let storedURL = sessionStorage.getItem("homeurlredirect");
        setUrl(storedURL);

        setTournamentList(tournaments)
        const intervalId = setInterval(() => {
            getTournamentListEvryfiveseconds();
        }, 5000);

        return () => clearInterval(intervalId);


    }, []);




    const observer = useRef();

    const lastItemRef = useCallback(
        (node) => {
            if (loadingpage || !hasMore) return;

            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && !loadingpage) {
                        setPage((prev) => prev + 1);
                    }
                },
                {
                    root: null,        // viewport
                    rootMargin: "0px", // no early trigger
                    threshold: 1.0     // 100% visible
                }
            );

            if (node) observer.current.observe(node);
        },
        [loadingpage, hasMore]
    );






    const getTournamentListEvryfiveseconds = async () => {
        try {
            const siteface = sessionStorage.getItem("siteId") || null;


            const uid = Date.now() + '-' + Math.random().toString(36).slice(2);
            const url = `https://${DomainUrl}/ballagames/list?playerToken=${playertoken}&siteId=${siteface}&uid=${uid}`;

            const response = await fetch(url, { method: "GET" });
            const res = await response.json();



            if (res?.success && res?.data) {
                res.data.map((item, index) => {

                    if (item.status == "PLAY" && item.playerStatus == "REGISTERED") {
                        sessionStorage.setItem("TournamentId", item.tournamentId);
                        if (sessionStorage.getItem('TRP')) {
                            // if(sessionStorage.getItem('TRP') == 'RRN'){
                            // }
                        } else {
                            sessionStorage.setItem('TRP', true)
                            setGamelaunchpopup(true)
                            setTimeout(() => {
                                // setGamelaunchpopup(false)

                                onRegisterSuccess();

                            }, 2000)
                        }
                    }

                })

                const formattedData = Array.isArray(res.data) ? res.data : [res.data];
                setTournamentList(formattedData);
            }
            else {
                setTournamentList([]);
            }

        } catch (error) {
            console.error("Tournament API Error:", error);
            return null;
        }
    };

    // const TournmentGamelaunch = (tournmrtidlaunch) => {

    //     sessionStorage.setItem("TournamentId", tournmrtidlaunch);
    //     onRegisterSuccess();
    // };
    const TournmentGamelaunch = (tournmrtidlaunch) => {
        setLaunchedTournament(tournmrtidlaunch);
        sessionStorage.setItem("TournamentId", tournmrtidlaunch);
        sessionStorage.setItem("TournamentIdReload", tournmrtidlaunch);
        let PlayerTokenOld = sessionStorage.getItem("playerToken");
        sessionStorage.setItem("previousToken", PlayerTokenOld)
        onRegisterSuccess();
    };

    const fetchLeaderboard = async (tournamentId) => {
        const uid = Date.now() + '-' + Math.random().toString(36).slice(2);
        sessionStorage.setItem("TournamentId", tournamentId);
        if (loadingpage || !hasMore) return;

        setPlayeslist(false);
        setActiveModal(true);
        setLoadingpage(true);

        try {
            const siteface = sessionStorage.getItem("siteId") || null;

            const response = await fetch(
                `https://${DomainUrl}/ballagames/leaderBoard?tournamentId=${tournamentId}&face=${siteface}&page=0&size=${ITEMS_PER_PAGE}&uid=${uid}`
            );

            const result = await response.json();
           

            //   const newItems = resultdata.content || [];
            if (result) {
                const newItems = result.content || [];

                if (newItems.length === 0) {
                    setHasMore(false);
                } else {
                    const formattedItems = newItems.map((p) => ({
                        id: p.playerId,
                        Nickname: p.loginName,
                        Rank: p.rank,
                        score: p.score,
                        Prize: p.prizeAmount,
                        chips: p.availableChips
                    }));

                    setPlayers((prev) => [...prev, ...formattedItems]);

                    setHasMore(!result.last);
                }
            }
        } catch (error) {
            console.error("Error fetching leaderboard:", error);
        } finally {
            setLoadingpage(false);
        }
    };


    const closePopup = () => {
        setSuccessPopup(false);
        seterrorPopup(false)
        setActiveModal(null);
        setActiveModalFinalrank(null);
        setModalData([]);
    };

    useEffect(() => {
        setLoading(false);
    }, [tournamentList]);

    const FetchTournamentListOnRefresh = () => {
        setLoading(true);
        sessionStorage.removeItem("TournamentIdReload");
        Russiantournamnet()
    }


    const RedirectLobbyoriv = () => {
        window.parent.postMessage("GAME_OVER", "*");
        // const redirectURL = sessionStorage.getItem("homeurlredirect");

        // if (redirectURL) {
        //     window.location.href = redirectURL;
        // } else {
        //     // fallback to same domain root
        //     // window.location.href = window.location.origin;
        // }


    };

    const handleUnregister = async (rptournamentId) => {
        sessionStorage.setItem("TournamentId", rptournamentId);

        const siteface = sessionStorage.getItem("siteId") || null;
        setLoading(true);
        try {
            const response = await fetch(`https://${DomainUrl}/ballagames/unregister`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    playerToken: playertoken,
                    tournamentId: rptournamentId,
                    face: siteface
                }),
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const result = await response.json();
            console.log(result)
            if (result.success) {
                sessionStorage.removeItem("TournamentIdReload");
                getTournamentListEvryfiveseconds();
                Russiantournamnet();
                setRegisteredTournament(rptournamentId);
                setisrigetration("COMPLETED")
                seterrorPopup(true)
                seterrorMessage("Successfully Unregistered to the Tournament");
            }
            else {
                seterrorMessage(result.message || "UnRegistration Failed");
                seterrorPopup(true)
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="poker-lobby-bg">


            <div className="Rptourmentheading">
                <h1 className="russian-poker-header">Russian Poker Tournaments</h1>
            </div>

            <div className="lobby-wrapper">
                {/* 🔥 Hide lobby cards when leaderboard is active */}
                {!activeModal &&
                    (Array.isArray(tournamentList) && tournamentList.length > 0 ? (
                        tournamentList.map((t, index) => {
                            const formatDateTime = (dateString) => {
                                if (!dateString) return "";


                                return new Date(dateString).toLocaleString("en-IN", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                });


                            };
                            let startTimecount = t.startTime

                            
                            const remaining = new Date(startTimecount).getTime() - currentTime

                            const showTimer = remaining > 0 && remaining <= 60000;
                            const seconds = Math.max(0, Math.ceil(remaining / 1000));

                            const startDate = formatDateTime(t.startTime);
                            const endDate = formatDateTime(t.endTime);

                            const renderActionButton = () => {
                                if (t.status === "OPEN" && t.playerStatus === "UNREGISTERED") {

                                    return (
                                        <button id="playtp" onClick={() => handleRegister(t.tournamentId)}>
                                            {tLabel.register}
                                        </button>
                                    );
                                }
                                if (t.startTime)

                                    if (
                                        t.playerStatus === "REGISTERED" &&
                                        t.status === "OPEN" &&
                                        t.status !== "PLAY" &&
                                        t.status !== "COMPLETED"
                                    ) {
                                        return (
                                            <button id="playtp" onClick={() => handleUnregister(t.tournamentId)}>
                                                {tLabel.unregister}
                                            </button>
                                        );
                                    }

                                if (t.playerStatus === "REGISTERED" && t.status === "PLAY") {
                                    const isLaunched = launchedTournament === t.tournamentId; 

                                    return (
                                        // <button className="play-button-glow" id="playtp" onClick={() => TournmentGamelaunch(t.tournamentId)}>
                                        //     {tLabel.play}
                                        // </button>

                                        <button id="playtp"
                                            className={`play-button ${!isLaunched ? "play-button-glow" : ""}`}
                                            disabled={isLaunched}
                                            onClick={() => TournmentGamelaunch(t.tournamentId)}
                                        >
                                            {isLaunched ? "Play" : tLabel.play}
                                        </button>
                                    );
                                }

                                return null;
                            };

                            return (
                                <div
                                    key={t.tournamentId}
                                    className="lobby-card"
                                    style={{ animationDelay: `${index * 0.15}s` }}
                                >
                                    <div className="lobby-content">
                                        <div className="tournament-header-row">
                                            <h2 id="tournament-name" className="tournament-name">{t.name}</h2>
                                            <p className="tour-status">
                                                {tLabel.status}: <span id="statustournament">
                                                    {statusMap[t.status] ?? t.status}
                                                </span>

                                            </p>
                                        </div>
                                         {showTimer && (
                                        <p className="countdown">
                                            ⏳ Tournament starts in: {seconds}s
                                        </p>
                                        )} 
                                        <div className="lobby-info">
                                            <div className="info-column">

                                                <p id="tourystatus">
                                                    <img src={tournydate} /> {tLabel.startTime}:
                                                    <span id="spanname">{startDate}</span>
                                                </p>
                                                <p id="tourystatus">
                                                    <img src={tournybuyin} /> {tLabel.entryFee}:
                                                    <span id="spanname">{t.netAmountToTournament}+{t.platformFee}</span>{t.currency}
                                                </p>

                                            </div>

                                            <div className="info-column">


                                                <p id="tourystatus">
                                                    <img src={tournydate} /> {tLabel.endTime}:
                                                    <span id="spanname">{endDate}</span>
                                                </p>


                                                <p id="tourystatus">
                                                    <img src={tournyprizepool} /> {tLabel.prizePool}:
                                                    <span id="spanname">{t.prizePool} {t.currency}</span>
                                                </p>
                                                <p id="tourystatus">
                                                    <img src={tournyplayers} /> {tLabel.registeredPlayerList}:
                                                    <span id="spanname">{t.registeredPlayerList}</span>
                                                </p>
                                            </div>
                                           
                                        </div>

                                        <div className="register-button-container">
                                            {renderActionButton()}

                                            <button
                                                onClick={() => {
                                                    setActiveTournament(t.tournamentId);
                                                    setActiveTab("Leaderboard");
                                                    setModalData([]);
                                                    fetchLeaderboard(t.tournamentId);
                                                }}
                                            >
                                                {tLabel.playerList}
                                            </button>
                                        </div>
                                    </div>
                                </div>



                            );
                        })
                    ) : (
                        <p className="Notournamnets">No Tournaments Available</p>
                    ))}
            </div>

            {gamelaunchpopup && (
                <div
                    className="game-launch-overlay"
                    onClick={() => setGamelaunchpopup(false)}
                >
                    <div
                        className="game-launch-popup"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="close-btngamelaunch"
                            onClick={() => setGamelaunchpopup(false)}
                        >
                            ✕
                        </button>

                        <p>
                            Launching Russian Poker Tournament…
                            <span className="dots"></span>
                        </p>
                    </div>
                </div>
            )}
            {activeModal && (
                <div className="leaderboard-modal">
                    <div className="table-wrapper">

                        <button
                            className="leaderboard-close-btn"
                            onClick={() => {
                                setActiveModal(false);
                                setPlayers([]);
                                setPage(0);
                                setHasMore(true);
                                setPlayeslist(true);
                            }}
                            aria-label="Close Leaderboard"
                        >
                            ×
                        </button>

                        <h2>Tournament Player List</h2>

                        <table className="leaderboard-table">
                            <thead>
                                <tr>
                                    <th className="textleft">Nickname</th>
                                    <th className="textright">Score</th>
                                    <th className="textright">Rank</th>
                                    <th className="textright">Prize</th>
                                </tr>
                            </thead>

                            <tbody>
                                {players.length > 0 &&
                                    players.map((player, index) => {
                                        const isLast = index === players.length - 1;

                                        return (
                                            <tr
                                                key={player.id || index}
                                                ref={isLast ? lastItemRef : null}
                                            >
                                                <td className="textleft">{player.Nickname || "-"}</td>

                                                <td className="textright">
                                                    {player.score !== null &&
                                                        player.score !== undefined
                                                        ? player.score
                                                        : player.chips ?? "-"}
                                                </td>

                                                <td className="textright">{player.Rank ?? "-"}</td>

                                                <td className="textright">{player.Prize ?? "-"}</td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>

                        {loadingpage && (
                            <p className="loading-text">Loading...</p>
                        )}

                        {!loadingpage && players.length === 0 && (
                            <p className="end-text">No Records Found</p>
                        )}

                    </div>
                </div>
            )}

            {isplayerlist && (<div className="Refreshicontournment">
                <button className="refresh_icon" onClick={FetchTournamentListOnRefresh} title="Refresh">
                    <img src={refreshicon} />
                </button>
            </div>
            )}

            <div className="close_btn_wrappertournamentlobby">
                <img
                    src={riverlog}
                    alt="Logo"
                    className="riverlog"
                    onClick={RedirectLobbyoriv}
                />
            </div>

            {/* {isUrl && (<div className="close_btn_wrappertournamentlobby">
                <button
                    className="close_btntournamentlobby"
                    onClick={(e) => RedirectLobbyoriv()}
                    aria-label="Close"
                >
                    ×
                </button>
            </div>
            )} */}
            {/* <div className="close_btn_wrappertournamentlobby">
                <button
                    className="close_btntournamentlobby"
                    onClick={(e) => RedirectLobbyoriv()}
                    aria-label="Close"
                >
                    ×
                </button>
            </div> */}

            {loading && (
                <div className="loader-overlay">
                    <span className="loader_rptournment"></span>
                </div>
            )}

            {successPopup && (
                <div className="success-popup">
                    <div className="popup-content">
                        <h2>{transactionType ? "RebuySuccessfull" : "Registration Successful!"}</h2>
                        <p>{transactionType ? "Please Continue playing" : "You are now registered for the tournament."}</p>
                        <button onClick={closePopup}>OK</button>
                    </div>
                </div>
            )}

            {errorPopup && (
                <div className="success-popup">
                    <div className="popup-content">
                        <h2>{errormessage}</h2>
                        <button onClick={closePopup}>OK</button>
                    </div>
                </div>
            )}
        </div>

    );
};

export default RussianPokerLobby;